import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

export const subscriptionCardStyles = {
	subscriptionPlanCardWrapper: {
		flexShrink: 0,
		backgroundColor: 'colors.dark6',
		borderRadius: '4px',
		position: 'relative',
	},
	subscriptionPlanCardCont(isHighlighted, openedMobilePricingPlansDetails, planName, isMobile) {
		return {
			height: '100%',
			width: 'auto',
			minWidth: '280px',
			minHeight:
				isMobile && openedMobilePricingPlansDetails.has(planName)
					? '590px'
					: { xs: 'auto', md: '560px' },
			marginBottom: '16px',
			borderRadius: '8px',
			backgroundColor: isHighlighted && 'colors.green',
			border: isHighlighted && `2px solid ${colorPalette.green}`,
			overflow: 'hidden',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			position: 'relative',
		};
	},
	subscriptionPlanCard: {
		width: '100%',
		minHeight: 'inherit',
		borderRadius: '8px',

		display: 'flex',
		flexDirection: 'column',

		overflow: 'hidden',
	},
	mostBoughtBadge: {
		position: 'absolute',
		top: '20px',
		right: '-32px',

		padding: '8px 26px',
		rotate: '47deg',
		zIndex: 10,
		clipPath: 'polygon(22% 0%, 75% 1%, 100% 100%, 0% 100%);',
		backgroundColor: 'colors.green',
	},

	cardOffer: {
		width: '100%',
	},
	nonExpiringTextCont: {
		width: 'fit-content',
		border: `1px solid ${colorPalette.light3}`,
		padding: '0px 8px',
		borderRadius: '40px',
	},
	nonCommercialUsageText: {
		width: 'fit-content',
		padding: '0px 8px',
		borderRadius: '40px',
		marginLeft: '5px',
		border: `1px solid ${colorPalette.lightCoral}`,
	},
	subscriptionPlanCardHeader: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'center',
		gap: '4px',
	},

	subscriptionPlanCardContent: {
		borderRadius: '8px',
		padding: '24px 16px',
		flexGrow: 1,
		backgroundColor: 'colors.dark4',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	subscriptionPlanCardDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		borderRadius: '4px',
		position: 'relative',
		width: '100%',
	},
	subscriptionPlanCardDetailsWrapper: {
		position: 'relative',
		width: '100%',
	},
	priceContainer: {
		width: '100%',
		minHeight: '63px',
		gap: '8px',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
	},
	subscriptionPlanCardPrice: {
		display: 'flex',
		maxHeight: '560px',
		flexDirection: 'column',
		gap: '24px',
	},
	subscriptionPlanCardDivider: {
		width: '100%',
		height: 0,
		borderWidth: '0 0 1px 0',
		borderStyle: 'solid',
	},
	subscriptionPlanCardOffersSection: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start',
		gap: '4px',
	},
	subscriptionPlanCardOffer: {
		textAlign: 'left',

		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	},

	subscriptionPlanCardSubscribeButton(isHighlighted) {
		return {
			padding: '6px 12px',
			border: isHighlighted ? '1px solid transparent' : `1px solid ${colorPalette.green}`,
			backgroundColor: isHighlighted ? 'colors.green' : 'colors.dark4',
			color: isHighlighted ? 'colors.dark6' : 'colors.green',
			width: '100%',
			gap: '6px',

			textTransform: 'none',

			'&:hover': {
				backgroundColor: isHighlighted ? 'colors.green' : 'colors.dark4',
				color: isHighlighted ? 'colors.dark6' : 'colors.green',
			},

			'&.Mui-disabled': {
				color: 'colors.light5',
				backgroundColor: 'colors.dark2',
				border: '1px solid transparent',
			},
		};
	},
	seeMoreFeaturesButton: {
		border: `1px solid ${colorPalette.light3}`,
		borderRadius: '4px',
		color: 'colors.light4',
		textTransform: 'none',
		paddingY: '8px',
		cursor: 'pointer',
	},
	subtext: {
		margin: '40px 15vw 0',
	},
};
